import isEmpty from 'lodash/isEmpty';
import {
         FETCH_ATIVIDADES_LISTA,
         FETCH_DESEMPENHO_ALUNO,
         FETCH_ALL_QUESTAO,
         FETCH_ALL_PALAVRA,
         ADD_QUESTAO,
         ADD_PALAVRA,
         UPDATE_QUESTAO,
         UPDATE_PALAVRA,
         UPDATE_UPLOAD_IMAGEM,
         REMOVE_ATIVIDADE,
         REMOVE_PALAVRA,
         REMOVE_QUESTAO,
         ANULAR_ATIVIDADE,
         CLOSE_MODAL,
         FETCH_ID_ATIVIDADE} from '../actions/atividadesAction';

const INITIAL_STATE = { 
                        closeModal           : false,
                        turma                : null,
                        disciplina           : null,
                        tipo                 : null,
                        titulo               : null,
                        fetch_id_atividade   : null,
                        allAtividadesLista   : [],
                        allDesempenhoAluno   : [],
                        fetch_all_questao    : [],
                        fetch_all_palavra    : [],
                      };

export default function(state = INITIAL_STATE,action){

    switch (action.type) {

        case FETCH_ID_ATIVIDADE:
          return { ...state, fetch_id_atividade:action.payload.data }

        case FETCH_ATIVIDADES_LISTA:
          return { ...state, allAtividadesLista:(action.payload.data?action.payload.data:[]) }

        case FETCH_DESEMPENHO_ALUNO:
          return { ...state, allDesempenhoAluno:(action.payload.data?action.payload.data:[])}

        case FETCH_ALL_QUESTAO:
       
          return {  
                    fetch_all_questao : (action.payload.data.questoes?action.payload.data.questoes:[]),
                    turma             : action.payload.data.turma,
                    disciplina        : action.payload.data.disciplina,
                    titulo            : action.payload.data.titulo,
                    tipo              : action.payload.data.tipo
                  }

        case FETCH_ALL_PALAVRA:
       
          return { 
                    fetch_all_palavra : (action.payload.data.palavras?action.payload.data.palavras:[]),
                    turma             : action.payload.data.turma,
                    disciplina        : action.payload.data.disciplina,
                    titulo            : action.payload.data.titulo,
                    tipo              : action.payload.data.tipo
                  }

        case ADD_QUESTAO:
          return { 
                  ...state, 
                  fetch_all_questao : [action.payload.data[0],...state.fetch_all_questao]
                }

        case ADD_PALAVRA:
          return { 
                 ...state, 
                 fetch_all_palavra : [action.payload.data[0],...state.fetch_all_palavra]
                }

        case CLOSE_MODAL:
          return { 
                  ...state, 
                  closeModal : action.payload
                 }

        case UPDATE_QUESTAO:
            const filtroQuestao = state.fetch_all_questao.filter((item) =>{
              if (item.ati_que_id === action.payload.data.ati_que_id) {
                  item.ati_que_pergunta = action.payload.data.ati_que_pergunta;
                  item.ati_que_opcao_a  = action.payload.data.ati_que_opcao_a;
                  item.ati_que_opcao_b  = action.payload.data.ati_que_opcao_b;
                  item.ati_que_opcao_c  = action.payload.data.ati_que_opcao_c;
                  item.ati_que_opcao_d  = action.payload.data.ati_que_opcao_d;
                  item.ati_que_resposta = action.payload.data.ati_que_resposta;
                  item.ati_que_anexo    = action.payload.data.ati_que_anexo;
                  item.ati_que_tempo    = action.payload.data.ati_que_tempo;
                  item.ati_que_contexto = action.payload.data.ati_que_contexto;
              }
          });
          return { ...state,filtroQuestao }
      
        case UPDATE_PALAVRA:
     
              const filtroPalavra = state.fetch_all_palavra.filter((item) =>{
               if (item.ati_pal_id === action.payload.data.ati_pal_id) {
                  item.ati_pal_pergunta = action.payload.data.ati_pal_pergunta;
                  item.ati_pal_palavra  = action.payload.data.ati_pal_palavra;
                  item.ati_pal_tempo    = action.payload.data.ati_pal_tempo;
                  item.ati_pal_contexto = action.payload.data.ati_pal_contexto;
                }
              });
         
          return { ...state,filtroPalavra }

        case ANULAR_ATIVIDADE:
             
              const filtroAnular = state.allAtividadesLista.filter((item) =>{
               if (item.ati_id === action.payload.data.ati_id) {
                  item.status = 4;
                }
              });
         
          return { ...state,filtroAnular }

        case UPDATE_UPLOAD_IMAGEM:
            
              const filtroImagemUpload = state.fetch_all_questao.filter((item) =>{
               if (item.ati_que_id === action.payload.data.ati_que_id) {
                  item.ati_que_anexo = action.payload.data.ati_que_anexo;
                }
              });
         
          return { ...state,filtroImagemUpload }
        
        case REMOVE_ATIVIDADE:
          return { ...state, allAtividadesLista : state.allAtividadesLista.filter(item => item.ati_id !== action.payload) }      

        case REMOVE_PALAVRA:
          return {  ...state, fetch_all_palavra : state.fetch_all_palavra.filter(item => item.ati_pal_id !== action.payload) }  

        case REMOVE_QUESTAO:
          return { ...state, fetch_all_questao : state.fetch_all_questao.filter(item => item.ati_que_id !== action.payload) } 

        default:
           return state;
    }

}


// WEBPACK FOOTER //
// ./src/reducers/reducer_atividades.js